import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import CustomerAIQuizContainer from "./CustomerAIQuizContainer";
import CustomerAIResults from "./CustomerAIResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import { CustomerAIScores } from "./questions";
import { webhookService } from "../../shared/webhookService";

export interface CustomerAIResult {
  questionId: number;
  question: string;
  answer: string;
  scores: CustomerAIScores;
}

const CustomerAIQuiz: React.FC = () => {
  const [results, setResults] = useState<CustomerAIResult[]>([]);
  const [showQuiz, setShowQuiz] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const navigate = useNavigate();

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    setShowQuiz(true);
  };

  const handleQuizComplete = async (quizResults: CustomerAIResult[]) => {
    setResults(quizResults);

    // Prepare webhook data
    const webhookData = {
      quizName: "Customer AI Quiz",
      userInfo: userInfo || {},
      responses: quizResults.map((result, index) => ({
        questionNumber: index + 1,
        question: result.question,
        answer: result.answer,
      })),
      timestamp: new Date().toISOString(),
    };

    // Send to webhook (with automatic retry on failure)
    await webhookService.submitQuizData(webhookData);

    // Navigate to results
    navigate("results", { replace: true });
  };

  const handleRestart = () => {
    setResults([]);
    setShowQuiz(false);
    setUserInfo(null);
    navigate(".", { replace: true });
  };

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            showQuiz ? (
              <CustomerAIQuizContainer onQuizComplete={handleQuizComplete} />
            ) : (
              <UserInfoForm
                onSubmit={handleUserInfoSubmit}
                subtitle="Discover Your AI Customer Service Opportunity"
              />
            )
          }
        />
        <Route
          path="results"
          element={
            <CustomerAIResults results={results} onRestart={handleRestart} />
          }
        />
      </Routes>
    </div>
  );
};

export default CustomerAIQuiz;
